<template>
  <div class="gallery">
    <div class="gallery-image">
      <img src="../assets/gallery/gallery-top.png" :style="{width : topImageSize[0], height : topImageSize[1], 'margin-left' : topImageSize[2], 'margin-top' : topImageSize[3]}" />
      <div class="gallery-logo">
        <h1> GALLERY </h1>
      </div>
    </div>
    <div class="gallery-wrapper">
      <div class="gallery-text-wrap">
        経営・管理部門のプロフェッショナルがその経験知識を生かし、東京２３区を中心とした価値あり物件をご提案・ご紹介いたします。
      </div>
    </div>
    <div class="gallery-box-wrapper">
      <div v-for='n in 8' :key='n' class="gallery-box">
        <galleryBox :p_id="n-1 + ''"/>
      </div>
    </div>
  </div>
</template>

<script>

import galleryBox from '@/components/gallery/galleryBox.vue'

export default {
  name: 'gallery',
  props: {
    msg: String
  },
  components: {
    galleryBox
  },
  data: function () {
    this.w_width = window.innerWidth
    this.w_height = window.innerHeight
    this.rate = 1.7633
    this.result = this.computeResize(this.w_width, this.w_height, this.rate)

    return {
      w_width: window.innerWidth,
      w_height: window.innerHeight,
      topImageSize: this.result
    }
  },
  methods: {
    handleResize: function () {
      this.w_width = window.innerWidth
      this.w_height = window.innerHeight
      this.rate = 1.7633
      this.topImageSize = this.computeResize(this.w_width, this.w_height, this.rate)
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}

</script>

<style lang="scss">
  @import url(http://fonts.googleapis.com/earlyaccess/notosansjapanese.css);

  .gallery{
    overflow: hidden;
    margin: 0;
  }
  .gallery-image{
    overflow: hidden;
    width: 100vw;
    height: 100vh;

    text-align: center;

    @media (max-width: 550px) {
      margin-top: 0px;
      text-align: left;
    }
  }
  .gallery-logo{
    position: absolute;
    top: 7.1vw;
    left: 13.2vw;

    h1 {
      font-family: Noto Sans Japanese, Bold;
      display: inline-block;
      font-size: 5.5vw;
      color: #fff;
    }
    .sp-none{

    }

    @media (max-width: 550px) {
      left: 5px;
      top: auto;
      bottom: 60px;
      h1 {
        font-size: 60px;
      }
      .sp-none{
        display: none;
      }
    }
  }

  .gallery-wrapper{
    margin: 2.1vw 6vw 0 6vw;
    overflow: hidden;

    .gallery-text-wrap{
      text-align: center;
      font-family: Noto Sans Japanese, Bold;
      margin-bottom: 1vw;
      font-size: 1.2vw;
      line-height: 2vw;
      color: #000;
    }

    @media (max-width: 550px) {
      width: 94vw;
      margin: auto;
      padding-top: 35px;

      .gallery-text-wrap{
        font-size: 15px;
        line-height: 43px;
        letter-spacing: 2px;
      }
    }
  }

  .gallery-box-wrapper{
    display: flex;
    justify-content: space-between;
    align-content: center;
    flex-wrap: wrap;
    margin-top: 6.1vw;
    margin-left: 2vw;
    margin-bottom: 9.8vw;
    width: 95.6vw;

    .gallery-box{
      width: 23.1vw;
      height: 23.1vw;
      margin-bottom: 1vw;
    }
    @media (max-width: 550px) {
      width: 94vw;
      margin: 100px auto;
      padding-bottom: 50px;

      .gallery-box{
        width: 46vw;
        height: 46vw;
        margin-bottom: 2vw;
      }
    }
  }
</style>
